import { createBrowserRouter } from 'react-router-dom';
import I18n from '../i18n';
import App from '../App';
import Home from '../pages/Home';
import Services from '../pages/Services';
import Price from '../pages/Price';
import News from '../pages/News';
import AboutUs from '../pages/AboutUs';
import ContactUs from '../pages/ContactUs';
import NewsInformation from '../pages/NewsInformation';
import AltynAfghanIntro from '../pages/intro/AltynAfghanIntro';
import AltynGroup from '../pages/intro/AltynGroup';
import Chart from '../pages/Chart';
import CompanyAltynRail from '../companies/CompanyAltynRail';
import NewsItem from '../pages/NewsItem';
import PageItem from '../pages/PageItem';
import Gallery from '../components/gallery/Gallery';
import FAQ from '../pages/FAQ';

const router = createBrowserRouter([
	{
		path: '/',
		element: (
			<I18n
				render={(setLocal, locale) => (
					<App
						onLocaleChanged={setLocal}
						locale={locale}
					/>
				)}
			/>
		),
		children: [
			{
				index: true,
				element: <Home />,
			},
			{
				path: '/services',
				element: <Services />,
			},
			{
				path: '/price',
				element: <Price />,
			},
			{
				path: '/news',
				element: <News />,
			},
			{
				path: '/about-us',
				element: <AboutUs />,
			},
			{
				path: '/contact-us',
				element: <ContactUs />,
			},
			{
				path: '/news/information',
				element: <NewsInformation />,
			},
			{
				path: '/pages/about/afghan',
				element: <AltynAfghanIntro />,
			},
			{
				path: '/pages/about/group',
				element: <AltynGroup />,
			},
			{
				path: '/chart',
				element: <Chart />,
			},
			{
				path: '/companies/altyn-rail',
				element: <CompanyAltynRail />,
			},
			{
				path: '/news-item/:newsId/*',
				element: <NewsItem />,
			},
			{
				path: '/faq',
				element: <FAQ />,
			},
			{
				path: '/gallery/list',
				element: <Gallery />,
			},
			{
				path: '/pages/item/:id/*',
				element: <PageItem />,
			},
		],
	},
]);

export default router;
